export const ContextMenuConstants = {
    MAKE_MENU_VISIBLE: "MAKE_MENU_VISIBLE", 
    MAKE_MENU_INVISIBLE: "MAKE_MENU_INVISIBLE",
    UPDATE_SCROLL_HEIGHT: "UPDATE_SCROLL_HEIGHT"
} 


